var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4939 5.59932H3.73537C2.72682 5.59932 1.90951 4.776 1.90951 3.76004C1.90951 2.74408 2.72682 1.92071 3.73537 1.92071H23.4938C24.0201 1.92071 24.4472 1.49109 24.4472 0.960357C24.4472 0.429626 24.0207 0 23.4938 0H3.73537C1.67258 0 0 1.68483 0 3.76283V18.1684C0.0033424 20.8501 2.16038 23.023 4.82255 23.0264H19.6247C22.2869 23.023 24.4439 20.8501 24.4472 18.1684V6.55968C24.4472 6.02953 24.0202 5.59932 23.4939 5.59932ZM19.6247 21.1056H4.83368C3.22021 21.1056 1.91228 19.7881 1.91228 18.1628V7.03707C2.46869 7.35381 3.09644 7.52009 3.73537 7.52009H22.5405V18.1908C22.5255 19.8032 21.2253 21.1028 19.6247 21.1056Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.941 16.4736C17.4147 16.4736 16.9876 16.0434 16.9876 15.5133V12.9185C16.9871 12.3884 17.4136 11.9576 17.9399 11.957C18.4662 11.9565 18.8938 12.3861 18.8944 12.9163C18.8944 12.9169 18.8944 12.9174 18.8944 12.9185V15.5189C18.891 16.0473 18.4656 16.4736 17.941 16.4736Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.6fc383b9.svg";
export { ForwardRef as ReactComponent };